/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Cancel_Confirm_BodyInputs */



/**
* | output |
* | --- |
* | "A run that is working stops at its next safe point. Actions it already carried out are not undone." |
*
* @param {Agent_Run_Cancel_Confirm_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_cancel_confirm_body = /** @type {((inputs?: Agent_Run_Cancel_Confirm_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Cancel_Confirm_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein laufender Lauf stoppt am nächsten sicheren Punkt. Bereits ausgeführte Aktionen werden nicht rückgängig gemacht.")
	return /** @type {LocalizedString} */ ("A run that is working stops at its next safe point. Actions it already carried out are not undone.")
});